(() => {
  if (window.__MagSnapBundleCartLoaded) return;
  window.__MagSnapBundleCartLoaded = true;

  const chinese = /^zh(?:-|$)/i.test(document.documentElement.lang);
  const translations = {"MAGSNAP SET":"MAGSNAP 套裝","1 Base Case + 3 Backplates":"1 個底殼 ＋ 3 張磁吸背板","VIEW 4 ITEMS":"查看 4 件商品","HIDE 4 ITEMS":"收起商品","3RD BACKPLATE FREE":"第 3 張磁吸背板免費","EDIT":"更改","REMOVE":"移除","YOUR 4-PIECE SET":"你的 4 件套裝","Components are managed together":"套裝商品會一併更改或移除","MagSnap bundle savings":"套裝優惠","Preview only — the US$46 / HK$354 server-side bundle price is not connected to checkout yet.":"目前為預覽，結帳時尚未套用 US$46／HK$354 套裝價。","REMOVING…":"正在移除…","BASE CASE":"底殼"};
  const text = value => chinese ? translations[value] || value : value;
  const caseName = value => chinese ? ({Black:'黑色',Clear:'透明',Green:'綠色',Pink:'粉紅色',Purple:'紫色'}[value] || value) + '底殼' : `${value} Base Case`.trim();
  const localeRoot = document.querySelector('[data-magsnap-cart-root]')?.dataset.magsnapCartRoot || window.Shopify?.routes?.root || '/';
  let ROOT = localeRoot.replace(/\/?$/, '/');
  const BUNDLE_KEY = '_magsnap_bundle_id';
  let rendering = false;
  let timer = null;
  let observer = null;

  const escHtml = (value = '') => String(value)
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');

  const cssEscape = (value = '') => {
    if (window.CSS?.escape) return CSS.escape(String(value));
    return String(value).replace(/([ #;?%&,.+*~\\':"!^$\[\]()=>|/@])/g, '\\$1');
  };

  const money = (cents, currency) => {
    const code = currency || window.Shopify?.currency?.active || 'USD';
    try {
      return new Intl.NumberFormat(code === 'HKD' ? 'en-HK' : 'en-US', {
        style: 'currency', currency: code, minimumFractionDigits: code === 'HKD' ? 0 : 2,
        maximumFractionDigits: code === 'HKD' ? 0 : 2
      }).format(cents / 100).replace('US$', 'US$').replace('HK$', 'HK$');
    } catch (_) {
      return code === 'HKD' ? `HK$${Math.round(cents / 100)}` : `US$${(cents / 100).toFixed(2)}`;
    }
  };

  const bundleProps = (item) => item?.properties || {};
  const bundleIdOf = (item) => bundleProps(item)[BUNDLE_KEY] || '';
  const roleOf = (item) => bundleProps(item)._magsnap_bundle_role || '';

  // Shopify currently exposes bundle components in Liquid but not always in Ajax cart JSON.
  function componentsFor(item) {
    if (item.item_components?.length) return item.item_components;
    const list = document.querySelector(`[data-magsnap-components="${cssEscape(item.key)}"]`);
    return list ? [...list.querySelectorAll('[data-component-title]')].map(el => ({
      product_title: el.dataset.componentTitle,
      variant_title: el.dataset.componentVariant,
      handle: el.dataset.componentHandle,
      image: el.dataset.componentImage
    })) : [];
  }

  function groupCart(cart) {
    const groups = new Map();
    (cart.items || []).forEach((item) => {
      const id = bundleIdOf(item);
      if (!id) return;
      if (!groups.has(id)) groups.set(id, []);
      groups.get(id).push(item);
    });
    const legacy = [...groups.entries()]
      .map(([id, items]) => ({ id, items }))
      .filter(group => group.items.length === 4 && group.items.filter(i => roleOf(i) === 'base').length === 1 && group.items.filter(i => roleOf(i) === 'backplate').length === 3);
    const bundles = (cart.items || []).filter(item => Number(item.product_id) === 10854815203633 && componentsFor(item).length === 4).map(parent => {
      const items = componentsFor(parent).map((item,index) => {
        const name = item.product_title || item.title || '';
        const isBase = /^(Black|Clear|Green|Pink|Purple) Case$/i.test(name) || /base-case-/.test(item.handle || item.url || '');
        const options = item.options_with_values || [];
        const device = options.find(x=>/iphone/i.test(x.value))?.value || (item.variant_title || item.title || '').match(/iPhone[^/·]+/)?.[0]?.trim() || '';
        return {...item,properties:{...item.properties,_magsnap_bundle_role:isBase?'base':'backplate',_magsnap_device:device,_magsnap_case_color:isBase?name.replace(/ Case$/i,''):'',_magsnap_design:name}};
      });
      return {id:'sdk:'+parent.key,items,parent};
    });
    return [...legacy,...bundles];
  }

  const builderImages = {"貓牲軍團-幫緊你幫緊你-mirror":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/mirror_Transparent_Background_iPhone_17_Backplate.webp?v=1790396679","cherry-candy":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/Cherry_Candy_Transparent_Background_iPhone_17_Backplate.webp?v=1790396803","velvet-petals":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/Velvet_Petals_Transparent_Background_iPhone_17_Backplate.webp?v=1790396796","lucky-black-cat":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/Lucky_Black_Cat_Transparent_Background_iPhone_17_Backplate.webp?v=1790396764","pink-bow":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/Pink_Bow_Transparent_Background_iPhone_17_Backplate.webp?v=1790396788","good-energy-only":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/GOOD_ENERGY_ONLY_Transparent_Background_iPhone_17_Backplate.webp?v=1790396727","貓牲軍團-唔meow你又唔醒水-mirror":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/MEOW_-mirror_Transparent_Background_iPhone_17_Backplate.webp?v=1790397135","cherry-ribbon":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/Cherry_Ribbon_Transparent_Background_iPhone_17_Backplate.webp?v=1790396780","midnight-blossom":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/Midnight_Blossom_Transparent_Background_iPhone_17_Backplate.webp?v=1790396746","heartline-cotton-candy":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/Heartline_Cotton_Candy__Transparent_Background_iPhone_17_Backplate.webp?v=1790397115","golden-hour-cat":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/Golden_Hour_Cat_Transparent_Background_iPhone_17_Backplate.webp?v=1790396915","bon-jour-croissant":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/Bon_Jour_Croissant_Transparent_Background_iPhone_17_Backplate.webp?v=1790396755","貓牲軍團-呢單嘢唔係我跟開-mirror":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/mirror_Transparent_Background_iPhone_17_Backplate_d1821e21-2d06-466c-941c-640e661e35e1.webp?v=1790397125","cherry-sweetheart":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/Cherry_Sweetheart_Transparent_Background_iPhone_17_Backplate.webp?v=1790396820","pastel-hydrangea":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/Pastel_Hydrangea_Transparent_Background_iPhone_17_Backplate.webp?v=1790396983","black-cat-hearts":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/Black_Cat_Hearts_Transparent_Background_iPhone_17_Backplate.webp?v=1790396812","sweet-lemonade":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/Sweet_Lemonade_Transparent_Background_iPhone_17_Backplate.webp?v=1790396736","heartline-buttercream":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/Heartline_Buttercream__Transparent_Background_iPhone_17_Backplate.webp?v=1790397104","貓牲軍團-槍聲響起歸家的信號-mirror":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/mirror_Transparent_Background_iPhone_17_Backplate_310e4376-875d-4510-b38e-4bb53a5f828d.webp?v=1790396697","cherry-crush":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/Cherry_Crush_Transparent_Background_iPhone_17_Backplate.webp?v=1790396905","tropical-hummingbird":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/Tropical_Hummingbird_Transparent_Background_iPhone_17_Backplate.webp?v=1790397000","i-am-glowing":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/I_AM_GLOWING_Transparent_Background_iPhone_17_Backplate.webp?v=1790396923","rose-sky-cat":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/Rose_Sky_Cat_Transparent_Background_iPhone_17_Backplate.webp?v=1790396965","heartline-sunday-blue":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/Heartline_Sunday_Blue__Transparent_Background_iPhone_17_Backplate.webp?v=1790397077","hibiscus-bloom-hot-cherry":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/Hibiscus_Bloom_Hot_Cherry__Transparent_Background_iPhone_17_Backplate.webp?v=1790397087","riviera-dot":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/Riviera_Dot_Transparent_Background_iPhone_17_Backplate.webp?v=1790396718","midnight-starry-cat":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/Midnight_Starry_Cat_Transparent_Background_iPhone_17_Backplate.webp?v=1790396942","kindness-is-beautiful":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/Kindness_is_Beautiful_Transparent_Background_iPhone_17_Backplate.webp?v=1790396933","hibiscus-bloom-cocoa-cream":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/Hibiscus_Bloom_Cocoa_Cream__Transparent_Background_iPhone_17_Backplate.webp?v=1790397050","life-on-repeat-stripe-cherry-cloud":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/Life_on_Repeat_Stripe_Cherry_Cloud__Transparent_Background_iPhone_17_Backplate.webp?v=1790397041","island-wanderer":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/Island_Wanderer_Transparent_Background_iPhone_17_Backplate.webp?v=1790396827","hibiscus-bloom-sunset-cocoa":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/Hibiscus_Bloom_Sunset_Cocoa__Transparent_Background_iPhone_17_Backplate.webp?v=1790397096","verdant-orchard-cat":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/Verdant_Orchard_Cat_Transparent_Background_iPhone_17_Backplate.webp?v=1790397012","navy-blush-dot":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/Navy_Blush_Dot_Transparent_Background_iPhone_17_Backplate.webp?v=1790396837","wine-cream-dot":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/Wine_Cream_Dot_Transparent_Background_iPhone_17_Backplate.webp?v=1790396847","pink-ballet-dot":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/Pink_Ballet_Dot_Transparent_Background_iPhone_17_Backplate.webp?v=1790396855","espresso-blue-dot":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/Espresso_Blue_Dot_Transparent_Background_iPhone_17_Backplate.webp?v=1790396896","creme-cherry-dot":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/Creme_Cherry_Dot_Transparent_Background_iPhone_17_Backplate.webp?v=1790396880","black-harlequin":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/Black_Harlequin_Transparent_Background_iPhone_17_Backplate.webp?v=1790396872","blue-jellyfish":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/Blue_Jellyfish_Transparent_Background_iPhone_17_Backplate.webp?v=1790396888","olive-daze":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/Olive_Daze_Transparent_Background_iPhone_17_Backplate.webp?v=1790396952","summer-wing-serenade":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/Summer_Wing_Serenade_Transparent_Background_iPhone_17_Backplate.webp?v=1790396973","take-a-breath":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/Take_a_breath_Transparent_Background_iPhone_17_Backplate.webp?v=1790396992","wild-girly-aesthetic":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/Wild_Girly_Aesthetic_Transparent_Background_iPhone_17_Backplate.webp?v=1790397022","life-on-repeat-stripe-navy-blush":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/Life_on_Repeat_Stripe_Navy_Blush__Transparent_Background_iPhone_17_Backplate.webp?v=1790397068","life-on-repeat-stripe-coffee-club":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/Life_on_Repeat_Stripe_Coffee_Club__Transparent_Background_iPhone_17_Backplate.webp?v=1790397034","貓牲軍團-呢單嘢唔係我跟開-kraftpaper":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/kraft_paper_Transparent_Background_iPhone_17_Backplate.webp?v=1790396689","貓牲軍團-唔meow你又唔醒水-kraftpaper":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/MEOW_-kraft_paper_Transparent_Background_iPhone_17_Backplate.webp?v=1790396708","貓牲軍團-幫緊你幫緊你-kraftpaper":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/kraft_paper_Transparent_Background_iPhone_17_Backplate_9a6728b6-45e6-44d2-bbff-a7b2a35ff77c.webp?v=1790397145","貓牲軍團-槍聲響起歸家的信號-kraftpaper":"https://cdn.shopify.com/s/files/1/0993/4992/2097/files/kraft_paper_Transparent_Background_iPhone_17_Backplate_9ccf46b6-5233-4dae-bc1f-9ba7cf931469.webp?v=1790397156"};
  function imageUrl(item) {
    const props = bundleProps(item);
    let handle = item.handle || props._magsnap_design_handle || props._magsnap_case_handle || '';
    if (!handle && item.url) {
      try { handle = new URL(item.url, location.origin).pathname.split('/products/')[1]?.split('/')[0] || ''; } catch (_) {}
    }
    try { handle = decodeURIComponent(handle); } catch (_) {}
    const component = handle && document.querySelector(`[data-component-handle="${cssEscape(handle)}"]`);
    const source = builderImages[handle] || component?.dataset.componentBuilderImage || item.image || item.featured_image?.url || '';
    if (!source) return '';
    try {
      const url = new URL(source, location.origin);
      if (url.hostname === 'cdn.shopify.com') url.searchParams.set('width', '400');
      return url.href;
    } catch (_) { return ''; }
  }

  function componentName(item) {
    const p = bundleProps(item);
    if (roleOf(item) === 'base') return caseName(p._magsnap_case_color || '');
    return p._magsnap_design || item.product_title || item.title || 'Backplate';
  }

  function buildBundleRow(group, currency) {
    const base = group.items.find(i => roleOf(i) === 'base');
    const backs = group.items.filter(i => roleOf(i) === 'backplate');
    const props = bundleProps(base || group.items[0]);
    const device = props._magsnap_device || '';
    const color = props._magsnap_case_color || '';
    const ordered = base ? [base, ...backs] : group.items;
    const saleTotal = group.parent ? group.parent.final_line_price : group.items.reduce((sum,item)=>sum+(item.final_line_price ?? item.line_price ?? 0),0);
    const componentList = group.parent && document.querySelector(`[data-magsnap-components="${cssEscape(group.parent.key)}"]`);
    const originalTotal = group.parent ? Number(componentList?.dataset.magsnapRetailTotal || 0) : group.items.reduce((sum,item)=>sum+(item.original_line_price ?? item.line_price ?? 0),0);
    const collage = ordered.map((item, i) => {
      const src = imageUrl(item);
      return `<span class="mscb-collage-item mscb-collage-${i}">${src ? `<img src="${escHtml(src)}" alt="">` : ''}</span>`;
    }).join('');
    const details = ordered.map((item, i) => {
      const role = roleOf(item) === 'base' ? text('BASE CASE') : (chinese ? `磁吸背板 ${i}` : `BACKPLATE ${i}`);
      const src = imageUrl(item);
      return `<div class="mscb-component">
        <span class="mscb-component-img">${src ? `<img src="${escHtml(src)}" alt="">` : ''}</span>
        <span class="mscb-component-copy"><small>${escHtml(role)}</small><b>${escHtml(componentName(item))}</b></span>
      </div>`;
    }).join('');

    const row = document.createElement('tr');
    row.className = 'mscb-row';
    row.dataset.bundleId = group.id;
    row.innerHTML = `<td colspan="4">
      <div class="mscb-card">
        <div class="mscb-summary">
          <div class="mscb-collage" aria-hidden="true">${collage}</div>
          <div class="mscb-copy">
            <span class="mscb-eyebrow">${text("MAGSNAP SET")}</span>
            <h3>${text("1 Base Case + 3 Backplates")}${group.parent?.quantity > 1 ? ` × ${group.parent.quantity}` : ''}</h3>
            <p>${escHtml(device)}${device && color ? ' · ' : ''}${escHtml(color ? caseName(color) : '')}</p>
            <button type="button" class="mscb-toggle" aria-expanded="false">${text("VIEW 4 ITEMS")} <span>+</span></button>
          </div>
          <div class="mscb-price">
            
            <strong>${money(saleTotal,currency)}</strong>
            ${originalTotal > saleTotal ? `<s style="display:block;color:#8b8681;font-size:14px;font-weight:400;line-height:1.4;margin-top:4px" aria-label="${chinese ? '原價' : 'Original price'} ${escHtml(money(originalTotal,currency))}">${money(originalTotal,currency)}</s>` : ''}
            
          </div>
          <div class="mscb-actions">
            <button type="button" class="mscb-remove">${text("REMOVE")}</button>
          </div>
        </div>
        <div class="mscb-details" hidden>
          <div class="mscb-details-head"><span>${text("YOUR 4-PIECE SET")}</span><small>${text("Components are managed together")}</small></div>
          <div class="mscb-components">${details}</div>
        </div>
      </div>
    </td>`;
    return row;
  }

  function clearPrevious() {
    document.querySelectorAll('.mscb-row').forEach(el => el.remove());
    document.querySelectorAll('.mscb-hidden-component').forEach(row => {
      row.classList.remove('mscb-hidden-component');
      row.removeAttribute('aria-hidden');
    });
    document.querySelectorAll('.mscb-preview-lock,.mscb-savings-line').forEach(el => el.remove());
  }

  function rowsForGroup(tbody, group) {
    return (group.parent ? [group.parent] : group.items).map(item => tbody.querySelector(`[data-key="${cssEscape(item.key)}"]`)).filter(Boolean);
  }

  function renderTables(groups, currency) {
    document.querySelectorAll('.cart-items__table tbody').forEach(tbody => {
      groups.forEach(group => {
        const rows = rowsForGroup(tbody, group);
        if (rows.length !== (group.parent ? 1 : 4)) return;
        const firstRow = rows[0];
        rows.forEach(row => {
          row.classList.add('mscb-hidden-component');
          row.setAttribute('aria-hidden', 'true');
        });
        firstRow.before(buildBundleRow(group, currency));
      });
    });
  }

  async function render() {
    if (rendering) return;
    const hasCart = document.querySelector('.cart-items__table tbody');
    if (!hasCart) return;
    // The deferred asset can execute before the cart table is parsed. Resolve its locale at render time.
    ROOT = (hasCart.closest('table')?.dataset.magsnapCartRoot || ROOT).replace(/\/?$/, '/');
    rendering = true;
    try {
      const response = await fetch(ROOT + 'cart.js', { cache: 'no-store' });
      if (!response.ok) return;
      const cart = await response.json();
      const groups = groupCart(cart);
      clearPrevious();
      if (!groups.length) return;
      const currency = cart.currency || window.Shopify?.currency?.active || 'USD';
      renderTables(groups, currency);

    } catch (error) {
      console.warn('MagSnap bundle cart preview:', error);
    } finally {
      rendering = false;
    }
  }

  function scheduleRender(delay = 80) {
    clearTimeout(timer);
    timer = setTimeout(render, delay);
  }

  async function removeBundle(bundleId, trigger) {
    if (!bundleId || trigger?.disabled) return;
    if (!window.confirm(chinese ? '要移除整套商品嗎？1 個底殼和 3 張磁吸背板會一併移除。' : 'Remove the whole set? This removes 1 base case and all 3 backplates.')) return;
    trigger?.closest('.mscb-card')?.querySelector('[data-remove-error]')?.remove();
    if (trigger) { trigger.disabled = true; trigger.textContent = text("REMOVING…"); }
    try {
      const response = await fetch(ROOT + 'cart.js', { cache: 'no-store' });
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      const updates = {};
      (cart.items || []).forEach(item => { if (bundleIdOf(item) === bundleId || ('sdk:'+item.key===bundleId && Number(item.product_id)===10854815203633)) updates[item.key] = 0; });
      if (!Object.keys(updates).length) { window.location.reload(); return; }
      const res = await fetch(ROOT + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates })
      });
      if (!res.ok) throw new Error('Remove failed');
      window.location.reload();
    } catch (_) {
      if (trigger) {
        trigger.disabled = false; trigger.textContent = text("REMOVE");
        const note = document.createElement('p');
        note.dataset.removeError = ''; note.setAttribute('role', 'alert');
        note.style.cssText = 'padding:12px 16px;color:#211d1a;font-size:14px;line-height:1.5';
        note.textContent = chinese ? '未能確認套裝是否已移除。請重新整理購物車確認，再決定是否重試。' : 'We could not confirm whether the set was removed. Refresh your cart to check before trying again.';
        trigger.closest('.mscb-card')?.append(note);
        trigger.focus();
      }
    }
  }

  document.addEventListener('click', event => {
    const toggle = event.target.closest('.mscb-toggle');
    if (toggle) {
      const card = toggle.closest('.mscb-card');
      const details = card?.querySelector('.mscb-details');
      if (!details) return;
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      details.hidden = open;
      toggle.innerHTML = `${open ? text('VIEW 4 ITEMS') : text('HIDE 4 ITEMS')} <span>${open ? '+' : '−'}</span>`;
      return;
    }
    const remove = event.target.closest('.mscb-remove');
    if (remove) {
      const id = remove.closest('.mscb-row')?.dataset.bundleId;
      removeBundle(id, remove);
    }
  });

  const start = () => {
    scheduleRender(0);
    observer = new MutationObserver(mutations => {
      if (rendering) return;
      const relevant = mutations.some(m => [...m.addedNodes].some(n => {
        if (n.nodeType !== 1 || n.matches?.('.mscb-row') || n.closest?.('.mscb-row')) return false;
        return Boolean(n.matches?.('.cart-items__table,.cart-items__table-row') || n.querySelector?.('.cart-items__table,.cart-items__table-row'));
      }));
      if (relevant) scheduleRender(120);
    });
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('cart:update', () => scheduleRender(100));
    document.addEventListener('cart:add', () => scheduleRender(100));
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();


